document.addEventListener('DOMContentLoaded', () => {
	const elements = document.querySelectorAll('.js-hero-search');

	if (elements.length) {
		elements.forEach((element) => {
			var heroSearchElement = new HeroSearch(element);
		});
	}
});

class HeroSearch {
	constructor(element) {
		this.rootElement = element;
		this.currentItem = this.rootElement.querySelector('#hero-search-selected-item');
		this.currentItemText = this.currentItem.querySelector('.text');
		this.dropdown = this.rootElement.querySelector('.dropdown-menu');
		this.dropdownItems = this.dropdown.querySelectorAll('.dropdown-item');
		this.submitButton = this.rootElement.querySelector('#hero-search-submit');
		this.input = this.rootElement.querySelector('#hero-search-input');
		this.form = this.rootElement.querySelector('.hero-search__form');

		if (this.rootElement) {
			this.init();
		}
	}

	init() {
		this.initDropdownButtons();

		this.form.addEventListener('submit', (e) => {
			e.preventDefault();

			window.open(
				`${this.currentItem.dataset.queryUrl}${encodeURIComponent(this.input.value)}`,
				'_blank',
			);
		});
	}

	initDropdownButtons() {
		this.dropdownItems.forEach((button) => {
			button.addEventListener('click', () => {
				this.dropdownItems.forEach((b) => b.classList.remove('is-selected'));

				button.classList.add('is-selected');

				this.currentItem.href = button.dataset.url;
				this.currentItem.setAttribute('data-query-url', button.dataset.queryUrl);
				this.currentItemText.innerText = button.innerText;
			});
		});
	}
}
